import {
    Component, OnInit,
    ViewEncapsulation
} from '@angular/core';
import { AccountSubscriptionsDetailsActionsPaymentMethod } from '../account.subscriptions.details.actions.payment-method';

@Component({
    selector: 'account-subscriptions-details-actions-payment-method-non-transparent-checkout',
    templateUrl: './account.subscriptions.details.actions.payment-method.non-transparent-checkout.component.html',
    styleUrls: ['./../../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsActionsPaymentMethodNonTransparentCheckoutComponent extends
    AccountSubscriptionsDetailsActionsPaymentMethod implements OnInit {

    ngOnInit() {
        this.choose(this.paymentMethod.id);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/account/subscriptions/details/actions/payment-method/non-transparent-checkout/account.subscriptions.details.actions.payment-method.non-transparent-checkout.component.ts